import {evite} from 'evite';
import {action, observable} from 'mobx';
import {PaginationWithFilters} from '~/common/pagination/paginationWithFilters';

const CONTACTS_PER_PAGE = 40;

export class BaseContactStore {
  constructor() {
    this.applySearch = evite.debounce(this.applySearch, 500);
  }

  setPagination(fetchFunction) {
    this.contacts = new PaginationWithFilters(CONTACTS_PER_PAGE, fetchFunction);
    // default sort
    this.contacts.sortBy = 'name';
  }

  @observable accessor groups = [];

  @observable accessor filters = {query: '', startsWith: '', group: ''};

  @observable accessor loading = false;

  searchBy = 'all';

  searchType = 'contains';

  /** *******************
   *Refreshing
   ******************** */
  refresh() {
    this.contacts.fetchCurrentPage();
  }

  /** *******************
   *Filters
   ******************** */

  setFilters() {
    this.contacts.setFilter(this.filters);
  }

  /** *******************
   *Filter By Group
   ******************** */

  hasAnyGroups = () => this.groups.length > 0;

  hasGroupFilterApplied = () => Boolean(this.filters.group);

  getCurrentGroupId = () => {
    if (!this.hasGroupFilterApplied()) return '';
    return this.filters.group;
  };

  getCurrentSearchParams = () => ({
    searchBy: this.searchBy,
    searchType: this.searchType,
    query: this._getSearchQuery(),
  });

  @action
  filterByGroup(groupId) {
    this.filters.group = groupId;
    this.setFilters();
    this.refresh();
  }

  @action
  clearGroup() {
    this.filters.group = '';
    this.setFilters();
    this.refresh();
  }

  /** *******************
   *Search
   ******************** */

  _getSearchQuery = () => this.filters.query;

  @action
  applySearch() {
    this.setFilters();
    this.refresh();
  }

  @action
  searchStartWith = async (query) => {
    this.changeSearchType('startsWith');
    this.filters.query = query;
    this.setFilters();
    await this.refresh();
  };

  @action
  clearSearch = () => {
    this.filters.query = '';
    this.setFilters();
    this.refresh();
  };

  @action
  search = (query) => {
    this.changeSearchType('contains');
    this.filters.query = query;
    this.applySearch();
  };

  setSearchBy = (searchBy) => {
    this.searchBy = searchBy;
  };

  changeSearchType = (type) => {
    this.searchType = type;
  };
}
